import React, { useState } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import InputField from '../common/InputField';
import { Button } from '../common/Button';
import { resetPassword } from '../../api/apiService';


const ResetPassword = () => {
    const navigate = useNavigate();
    const location = useLocation();
    const [newPassword, setNewPassword] = useState('');
    const [confirmPassword, setConfirmPassword] = useState('');
    const [errors, setErrors] = useState({});
    const [loading, setLoading] = useState(false);
    const [message, setMessage] = useState('');

    // Extract token from the URL
    const token = new URLSearchParams(location.search).get('token');

    const handleSubmit = async (e) => {
        e.preventDefault();
        setLoading(true);
        setErrors({});

        if (!newPassword || !confirmPassword) {
            setErrors({ general: 'Please fill in both password fields.' });
            setLoading(false);
            return;
        }

        if (newPassword !== confirmPassword) {
            setErrors({ general: 'Passwords do not match.' });
            setLoading(false);
            return;
        }

        try {
            const response = await resetPassword(token, newPassword);
            if (!response.error) {
                setMessage('Your password has been reset successfully.');
                setTimeout(() => navigate('/login'), 3000); // Redirect to login after 3 seconds
            } else {
                setErrors({ general: response.message });
            }
        } catch (error) {
            setErrors({ general: error.message });
        } finally {
            setLoading(false);
        }
    };

    return (
        <div className="min-h-screen flex flex-col items-center justify-center bg-gray-100">
            <form onSubmit={handleSubmit} className="bg-white p-8 rounded-lg shadow-md w-full max-w-md">
                <h2 className="text-2xl font-bold mb-6 text-center text-text">Reset Password</h2>
                {errors.general && <p className="text-primary text-sm mb-4">{errors.general}</p>}
                {message && <p className="text-green-600 text-sm mb-4">{message}</p>}

                <InputField
                    label="New Password"
                    type="password"
                    name="newPassword"
                    value={newPassword}
                    onChange={(e) => setNewPassword(e.target.value)}
                    placeholder="Enter your new password"
                    required
                    error={errors.newPassword}
                />

                <InputField
                    label="Confirm Password"
                    type="password"
                    name="confirmPassword"
                    value={confirmPassword}
                    onChange={(e) => setConfirmPassword(e.target.value)}
                    placeholder="Confirm your new password"
                    required
                    error={errors.confirmPassword}
                />

                <div className="flex justify-center">
                    <Button type="submit" disabled={loading} className="w-64">
                        {loading ? 'Resetting...' : 'Reset Password'}
                    </Button>
                </div>
            </form>
        </div>
    );
};

export default ResetPassword;